<div class="display-flex list-placeholder-wrapper align-items-center ">
    <img [src]="imgSrc" [alt]="description" class="mb-4">
    <div class="text-16 text-center mb-3">{{description}}</div>
    <vc-button variant="primary-outlined" (click)="onBtnClicked()">{{actionBtnText}}</vc-button>
</div>
